import { useTranslation } from 'react-i18next';
import { categories } from '@/data/categories';

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section id="categories" className="py-16 md:py-24 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-4">
            {t('categories.title')}
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">{t('categories.subtitle')}</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((c) => (
            <a
              key={c.key}
              href={c.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 overflow-hidden hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="relative w-full aspect-square overflow-hidden bg-background-100">
                <img
                  src={c.image}
                  alt={t(c.key)}
                  title={`${t(c.key)} — Basetao Spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex items-center gap-2 px-3 py-3">
                <span className="w-6 h-6 flex items-center justify-center text-secondary-600 group-hover:text-primary-600 transition-colors shrink-0">
                  <i className={`${c.icon} text-base`} />
                </span>
                <span className="text-sm font-semibold text-foreground-800 group-hover:text-primary-800 truncate">
                  {t(c.key)}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}